import { render, staticRenderFns } from "./wb.vue?vue&type=template&id=3d4625db&scoped=true"
import script from "./wb.vue?vue&type=script&lang=js"
export * from "./wb.vue?vue&type=script&lang=js"
import style0 from "./wb.vue?vue&type=style&index=0&id=3d4625db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4625db",
  null
  
)

export default component.exports